export const columns = [
  {
    accessorKey: "fileSizeThreshold",
    header: "File Size Threshold",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "fileTypes",
    header: "File Types",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "compressionEnabled",
    header: "Compression Enabled",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
